import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Card,
  CardContent,
  CssBaseline,
  IconButton,
  InputAdornment,
  Paper,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoginMobile from "../../assets/Login-Mobile.svg";
import LoginTablet from "../../assets/Login-Tablet.png";
import LoginWeb from "../../assets/Login-Web.svg";
import logo from "../../assets/logo.png";
import SipLogo from "../../assets/sip_logo.svg";
import axiosInstance from "../../common/services/axiosInstance";
import { useCharactersContext } from "../../hooks/Context";

const Login = (props:any) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width: 820px)");
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setShowLogin } = useCharactersContext();
  const BASE_URL = `${process.env.REACT_APP_API_URL}`;
  const [alertBoxState, setAlertBoxState] = useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: "success" as AlertColor,
  });
  const { setStudentName, setStudentId, setOrgId} = useCharactersContext();

  const handleCloseAlert = () => {
    setAlertBoxState({ ...alertBoxState, openAlert: false });
  };
  const vertical = "top";
  const horizontal = "center";

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  //const query = new URLSearchParams(props.location.search);
  //let loginId: any = "";  // Change const to let
 // let password: any = "";
 const { userName } = useParams<any>();
 const { userpassword } = useParams<any>();

  


  const handleLoginSuccess = (response: any) => {
    const studentName = response.data.studentName;
    setAlertBoxState({
      ...alertBoxState,
      openAlert: true,
      message: "Logged in Successfully..",
      severity: "success",
    });
    setShowLogin(true);
    navigate("/dashboard");
    localStorage.setItem("accessToken", response.data.access_token);
    localStorage.setItem("refreshToken", response.data.refresh_token);
    localStorage.setItem("userType", response.data.userType);
    localStorage.setItem("studentName", studentName);
    localStorage.setItem("studentId", response.data.studentid);
    localStorage.setItem("orgId", response.data.orgId);
    setStudentName(studentName);
    setStudentId(response.data.studentid);
    setOrgId(response.data.orgId);
    localStorage.setItem("studentId", response.data.studentid);
  };

  const handleLoginError = (error: any) => {
    console.log("Error: ", error);
    let errorMessage = "An error occurred. Please try again.";
    if (error.response) {
      if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.data && typeof error.response.data === 'object') {
        errorMessage = error.response.data.error ||
                      error.response.data.message ||
                      error.response.data.status ||
                      "An error occurred. Please try again.";
      }
    } else if (error.request) {
      errorMessage = "No response from server. Please check your connection and try again.";
    }
    setAlertBoxState({
      ...alertBoxState,
      openAlert: true,
      message: errorMessage,
      severity: "error",
    });
  };

  const signin = (loginId: string, password: string) => {
    axiosInstance
      .post(BASE_URL + "/api/iam/signin", { loginId, password })
      .then((response: any) => handleLoginSuccess(response))
      .catch((error: any) => handleLoginError(error));
  };

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data1 = new FormData(event.currentTarget);
    const data = Object.fromEntries(data1.entries());
    signin(data.loginId as string, data.password as string);
  };

  const [showLogin, setShowLogins] = useState(false);

  // useEffect
  useEffect(() => {
   
    console.log("userName "+ userName);
    
    if (userName  && userpassword) {
      signin(userName, userpassword);
    }
  }, []);

  return (
    <>
    
      {
       ((userName == undefined || userName == null || userName == "" || 
       userpassword == undefined || userpassword == null || userpassword == "") || showLogin)  ? 
    ( <>
    <Paper 
    
    sx={{
      backgroundImage: `url(${
        isMobile ? LoginMobile : isTablet ? LoginTablet : LoginWeb
      })`, // Conditionally set the backgroundImage
      backgroundSize: "cover", // Optionally adjust background properties
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      minHeight: "100vh",
    }}

  >
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertBoxState.openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={6000}
      >
        <Alert onClose={handleCloseAlert} severity={alertBoxState.severity}>
          {alertBoxState.message}
        </Alert>
      </Snackbar>

      <Card
        variant="outlined"
        sx={{
          borderRadius: "0px",
          marginLeft: isMobile || isTablet ? "auto" : "50vw",
          marginRight: isMobile || isTablet ? "auto" : "0",
          maxWidth: isMobile || isTablet ? "100vw" : "50vw",
          height: isMobile || isTablet ? "auto" : "100vh",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: isMobile || isTablet ? "0vh" : "2vh",
            }}
          >
            <Box>
              <img
                src={logo}
                alt="logo"
                width={isMobile || isTablet ? "200vw" : "250vw"}
                height="auto"
              />
            </Box>
            <Typography
              component="h1"
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontSize: isMobile || isTablet ? "3vh" : "5vh",
                margin: isMobile || isTablet ? "2vh" : "4vh",
              }}
            >
              Homework Portal
            </Typography>
            <form onSubmit={handleFormSubmit}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="loginId"
                label="Username"
                name="loginId"
                autoComplete="username"
                autoFocus
                value={loginId}
                onChange={(event) => setLoginId(event.target.value)}
                sx={{ paddingRight: 2.3 }}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ paddingRight: 2.3 }}
              />
              <Box
                m={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ marginBottom: isMobile || isTablet ? "2.5vh" : "auto" }}
              >
                <Button
                  type="submit"
                  // fullWidth
                  variant="contained"
                  sx={{ mt: 2, color: "white" }}
                >
                  Sign In
                </Button>
              </Box>
            </form>
            <Box sx={{ marginTop: isMobile || isTablet ? "4vh" : "10vh" }}>
              <img
                src={SipLogo}
                alt="logo"
                width={isMobile || isTablet ? "190vw" : "250vw"}
                height="auto"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  marginTop: "1vh",
                }}
              />
            </Box>
          </Box>
        </CardContent>
      </Card> </Paper> </>):<></>
      
}
    
    </>
  );
};
export default Login;
